import useDebounce from 'hooks/useDebounce';
import { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { useSearchCompaniesQuery } from 'services';

const SearchCompanyList = ({ selectProps, fieldValue, formik }: any) => {
	// state
	const [searchQry, setSearchQry] = useState<string | null>(fieldValue || null);

	// hooks
	const debouncedQry = useDebounce(searchQry, 500);

	// query
	const { data: searchData = [], refetch } = useSearchCompaniesQuery(debouncedQry);
	useEffect(() => {
		if (debouncedQry) {
			refetch();
		}
	}, [debouncedQry]);

	return (
		<CreatableSelect
			{...selectProps}
			isSearchable
			options={searchData}
			getOptionValue={(option: any) => option.id ?? option.value}
			getOptionLabel={(option: any) => option.companyName ?? option.label}
			onInputChange={(value: string) => {
				if (value.length > 0) {
					setSearchQry(value);
				}
			}}
			onBlur={formik.handleBlur}
			value={
				searchData?.find((addressObj: any) => addressObj.companyName === fieldValue) || {
					value: fieldValue,
					label: fieldValue,
				}
			}
			autoFocus={false}
			className="form-react-select"
			classNamePrefix="select"
		/>
	);
};

export default SearchCompanyList;
